// src/services/statusiService.js
import api from "@/api";

export async function getStatusi() {
  try {
    const res = await api.get("/statusi");
    return res.data; // [{ SifraID, Opis }]
  } catch (err) {
    console.error("STATUS API ERROR:", err);
    return [];
  }
}